import { getApi } from '../../../utils/api'

export function getDefaultConfig({ entity, params }) {
  return getApi({
    endpoint: `idwell-api/api/v3/table/tables/${entity.plural}/config/default/`,
    params,
  })
}
